// extracted by mini-css-extract-plugin
export default {"main":"instructions_main__oQc3i","top":"instructions_top__ZQtux","content":"instructions_content__iC9Nd","images":"instructions_images__90297"};